import { gql } from "@apollo/client";export default gql`query questionAggregate($where: question_bool_exp) {
    questionAggregate: question_aggregate(where: $where) {
        aggregate {
            count
        }
    }
}
`;
